module.exports = __webpack_public_path__ + "static/img/ruleTitle.45b65b89.png";